import React from "react";
import Createorganization from "./CreateOrganization";
import './css/dashboard.css';

const AddorganizationHomePage = () => <Createorganization />;

export default AddorganizationHomePage;
